import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Settings\UpdateSettingController::__invoke
* @see app/Http/Controllers/Settings/UpdateSettingController.php
* @route '/api/settings/{settingName}'
*/
const UpdateSettingController = (args: { settingName: string | number } | [settingName: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateSettingController.url(args, options),
    method: 'put',
})

UpdateSettingController.definition = {
    methods: ["put"],
    url: '/api/settings/{settingName}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Settings\UpdateSettingController::__invoke
* @see app/Http/Controllers/Settings/UpdateSettingController.php
* @route '/api/settings/{settingName}'
*/
UpdateSettingController.url = (args: { settingName: string | number } | [settingName: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { settingName: args }
    }

    if (Array.isArray(args)) {
        args = {
            settingName: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        settingName: args.settingName,
    }

    return UpdateSettingController.definition.url
            .replace('{settingName}', parsedArgs.settingName.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\UpdateSettingController::__invoke
* @see app/Http/Controllers/Settings/UpdateSettingController.php
* @route '/api/settings/{settingName}'
*/
UpdateSettingController.put = (args: { settingName: string | number } | [settingName: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateSettingController.url(args, options),
    method: 'put',
})

export default UpdateSettingController